import loginReducer from '../modules/login/reducers/loginreducer'
import dashboardreducer from '../modules/dashboard/reducers/dashboardreducer'
import userProfileReducer from '../modules/userprofile/reducers/userprofilereducer';
import workFlowReducer from '../modules/workflow/reducers/workflowreducer'
import adminReducer from '../modules/admin/reducers/adminreducer'
import secmasterReducer from '../modules/secmaster/reducers/secmasterreducer'

export default function getReducers() {
  return {
    loginReducer: loginReducer,
    dashboardReducer: dashboardreducer,
    userProfileReducer: userProfileReducer,
    workFlowReducer: workFlowReducer,
    adminReducer: adminReducer,
    secmasterReducer: secmasterReducer
  };
}
